import { SectionTitle } from '@basic';
import { UIPaths } from '@consts';
import { ChevronLeftIcon, XIcon } from '@icons';
import { setupForDark } from '@theme';
import classNames from 'classnames';
import * as _ from 'lodash';
import { useRouter } from 'next/router';
import { ReactElement } from 'react';
const Header = ({
  withBackArrow = false,
  onBackArrowClicked = null,
  withX = false,
  onXClicked = null,
  height = 24,
  centered = true,
  title = null,
  children = null,
  withUnderline = true,
  className = '',
  bold = false
}: {
  withBackArrow?: boolean;
  onBackArrowClicked?: () => void;
  withX?: boolean;
  onXClicked?: () => void;
  height?: number;
  centered?: boolean;
  title?: string;
  children?: ReactElement;
  className?: string;
  withUnderline?: boolean;
  bold?: boolean;
}) => {
  const router = useRouter();
  const moveToPreviousPage = () => {
    // very HACKY way of checking if there's a no previous router to jump back to
    if (
      router['components'] &&
      Object.keys(router['components']).length === 2 &&
      router['components']['/_app']
    ) {
      router.push(UIPaths.home());
    } else {
      router.back();
    }
  };
  const goBack = () => {
    if (onBackArrowClicked) {
      onBackArrowClicked();
      return;
    }

    moveToPreviousPage();
  };

  onXClicked = onXClicked || moveToPreviousPage;

  if (!_.isNil(title) && !_.isNil(children)) {
    throw new Error('Header component can only have title or children, not both');
  }

  if (withX && _.isNil(onXClicked)) {
    throw new Error('Header component with X button must have onXClicked prop defined');
  }

  let content = <div></div>;
  if (!_.isNil(children)) {
    content = children;
  } else if (!_.isNil(title)) {
    content = <SectionTitle text={title} center={centered} bold={bold} />;
  }
  return (
    <div
      className={classNames(
        height ? `h-[${height}px]` : '',
        'w-full px-xs py-lg flex flex-row items-center gap-sm justify-start',
        setupForDark('text-icon-primary', 'border-secondary'),
        withUnderline && 'border-b-[1px]',
        className
      )}
    >
      {withBackArrow && (
        <ChevronLeftIcon
          className='cursor-pointer'
          size={24}
          onClick={goBack}
          data-testid='header-back-arrow'
        />
      )}
      {!withBackArrow && centered && withX && (
        <div className='w-[24px]'>{/* spacer to make easier to keep the text in center*/}</div>
      )}
      <div
        className={classNames('flex flex-row grow max-w-[calc(100%-48px)]', {
          'justify-center': centered
        })}
      >
        {content}
      </div>
      {withBackArrow && centered && !withX && (
        <div className='w-[24px]'>{/* spacer to make easier to keep the text in center*/}</div>
      )}
      {withX && (
        <div
          className={classNames('cursor-pointer', setupForDark('text-icon-primary'))}
          onClick={onXClicked}
        >
          <XIcon size={24}></XIcon>
        </div>
      )}
    </div>
  );
};

export default Header;
